// reducer
import { initialState } from "@/store/MyRecipes/state";

export const allRecipesMutation = (state, data) => {
  // Vue.set(state.MyClients, "myClients", data);
  // state.MyClients.myClients = data;

  state.MyRecipes.myRecipes.list = [
    ...state.MyRecipes.myRecipes.list,
    ...data.list
  ];

  state.MyRecipes.myRecipes.pagination = data.pagination;
};

export const resetMyRecipes = state => {
  state.MyRecipes.myRecipes = initialState().myRecipes;
};
